// Liveflight design icons
// Each subdirectory contains icons in the standard design-icons format
// using export default '<svg>...</svg>' with var(--color) for customizable colors

// bags
export { extra_bag, trolley, backpack, luggage } from './bags/index.js'

// chevrons
export { chevron_up, chevron_right, chevron_left, chevron_down } from './chevrons/index.js'

// common
export { checked } from './common/index.js' 
export { geo } from './common/index.js' 
export { tick } from './common/index.js'
export { filters } from './common/index.js' 
export { default as mobile } from './common/mobile.js' 

// flight
export { carrier } from './flight/index.js'
export { large_bag } from './flight/index.js' 
export { sun_half } from './flight/index.js' 
export { default as traveler } from './flight/traveler.js' 
export { priority } from './flight/index.js' 
export { unlock } from './flight/index.js'
export { flight_ticket, plane, flight_start, flight_stop } from './flight/index.js'

// seat-map
export { seat_choice, seat_blocked, seat_best_for_infant } from './seat-map/index.js'

// social
export { facebook, instagram, linkedin, at_sign } from './social/index.js'
